import {
    GetTimelineAction,
    ResetTimeStripsAction,
    SetPlaybackModeAction,
    SetSpeedPlaybackAction,
    SetTimelineDateAction,
    SetZoomRulerValuesAction,
    SetZoomTimelineScaleAction
} from "./types";

export const setTimelineDate = (time: number, playbackMode?: string) : SetTimelineDateAction => {
    return {type: 'setTimelineDate', time, playbackMode}
};

export const getTimeline = (pane: number, startTime: number, endTime: number, continuationId: string | null) : GetTimelineAction =>
    ({type: 'getTimeline', pane, startTime, endTime, continuation_id: continuationId});

export const setZoomRulerValues = (duration: number, scaleMarkInterval: number, scaleTimeMarkInterval: number, title: string) : SetZoomRulerValuesAction =>
    ({type: 'setZoomRulerValues', duration, scaleMarkInterval, scaleTimeMarkInterval, title});

export const setZoomTimelineScale = (timelineScale: number) : SetZoomTimelineScaleAction => ({type: 'setZoomTimelineScale', timelineScale});

export const resetTimestrips = (time: number) : ResetTimeStripsAction => ({type: 'resetTimestrips', time});

export const setSpeedPlayback = (speed: number) : SetSpeedPlaybackAction => ({type: 'setSpeedPlayback', speed});

export const setPlaybackmode = (playbackMode: string, changeIconView: boolean = true) : SetPlaybackModeAction => ({type: 'setPlaybackMode', playbackMode, changeIconView});